<template>
    <div class="party-upload">
        <div id="doms" class="h-[64px] px-[20px] flex items-center justify-between"
            style="border-bottom: 1px solid #e5e5e5;">
            <div>
                <team v-if="rightpanelshow"></team>
            </div>
            <login></login>
        </div>
        <div class="insputs" ref="inputsRef">
            <div class="flex justify-end pr-[24px]"></div>
            <div v-for="(item, index) in inputTree" :key="index" class="break-inside-avoid">
                <div v-if="!item.custom" class="input-card px-[24px] py-[12px] gap-[12px]">
                    <div
                        class="mb-[12px] pt-[6px] text-[14px] text-[#374151] font-bold flex items-center justify-between">
                        <span>{{ item.labelName }}：</span>
                        <el-button type="primary" size="mini" v-if="item.key === 'title'"
                            @click="analyzeTextBYAI()">AI一键解析</el-button>
                    </div>
                    <div v-if="item.inputType === 'cascader'" style="flex: 1;">
                        <el-cascader v-model="item.defaultValue" :options="buildCascaderOptionsWithAdd(item)"
                            style="width: 100%" :placeholder="item.Placeholder" :filterable="true">
                            <template #default="{ data }">
                                <div class="flex items-center w-full">
                                    <span>{{ data.label }}</span>
                                    <template v-if="data.isAddRoot">
                                        <el-input v-model="cascaderRootInputMap[item.key]" size="small"
                                            placeholder="输入后回车" class=" w-[140px]" @keyup.enter="commitAddRoot(item)"
                                            @blur="commitAddRoot(item)" />
                                    </template>
                                    <template v-else-if="data.isAddChild">
                                        <el-input
                                            v-model="cascaderChildInputMap[childMapKey(item.key, data.parentValue)]"
                                            size="small" placeholder="输入后回车" class=" w-[140px]"
                                            @keyup.enter="commitAddChild(item, data.parentValue)"
                                            @blur="commitAddChild(item, data.parentValue)" />
                                    </template>
                                </div>
                            </template>
                        </el-cascader>
                    </div>
                    <div v-else-if="item.inputType === 'checkbox'" style="flex: 1;">
                        <div class="flex flex-wrap gap-[8px] items-center">
                            <div v-for="opt in item.options" :key="opt.value"
                                class="px-[10px] py-[6px] rounded-[6px] text-[12px] cursor-pointer select-none border"
                                :class="item.defaultValue.includes(opt.value) ? 'bg-[#eef2ff] border-[#6366f1] text-[#3f51b5]' : 'bg-[#f9fafb] border-[#e5e7eb] text-[#374151]'"
                                @click="toggleOption(item, opt.value)">{{ opt.label }}</div>

                            <template v-if="item.customize">
                                <template v-if="customizingMap[item.key]">
                                    <el-input v-model="newOptionMap[item.key]" size="small" placeholder="输入后回车添加"
                                        class="w-[140px]" @keyup.enter="commitCustomize(item)"
                                        @blur="commitCustomize(item)" />
                                </template>
                                <template v-else>
                                    <div class="px-[8px] py-[5px] rounded-[6px] text-[12px] cursor-pointer select-none border border-dashed bg-[#fafafa] text-[#6b7280] flex items-center gap-[4px]"
                                        @click="startCustomize(item)">
                                        <ElIcon size="14px">
                                            <Plus />
                                        </ElIcon>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </div>
                    <div v-else-if="item.inputType === 'multipleSelectCreate'" style="flex: 1;">
                        <el-input-tag v-model="item.defaultValue" placeholder="输入完毕后请点击回车键" filterable clearable>
                        </el-input-tag>
                    </div>
                    <div v-else-if="item.inputType === 'select'" style="flex: 1;">
                        <el-select v-model="item.defaultValue" :placeholder="item.Placeholder" filterable>
                            <el-option v-for="opt in item.options" :key="opt.value" :label="opt.label"
                                :value="opt.value" />
                        </el-select>
                    </div>
                    <div v-else-if="item.inputType === 'input'" style="flex: 1;">
                        <el-input v-model="item.defaultValue" :placeholder="item.Placeholder" />
                    </div>
                    <div v-else-if="item.inputType === 'richText'" style="flex: 1;">
                        <!-- <el-input v-model="item.defaultValue" :placeholder="item.Placeholder" type="textarea" />
                         
                          -->
                        <Editer v-model="item.defaultValue" />
                    </div>
                    <div v-else-if="item.inputType === 'color'" style="flex: 1;">
                        <div class="flex items-center gap-[10px] flex-wrap">
                            <div v-for="(c, i) in (Array.isArray(item.defaultValue) ? item.defaultValue : [])" :key="i"
                                class="flex items-center gap-[10px] px-[12px] py-[8px] rounded-[10px] bg-[#f8fafc] border border-[#e5e7eb]">
                                <div class="w-[20px] h-[20px] rounded-full  p-0 cursor-pointer"
                                    :style="{ backgroundColor: c }">
                                    <input type="color" v-model="item.defaultValue[i]"
                                        class="w-[20px] h-[20px] rounded-full p-0 cursor-pointer opacity-0" />
                                </div>
                                <span class="text-[12px] text-[#374151]">{{ c }}</span>
                                <span class="text-[#9ca3af] cursor-pointer text-[12px]"
                                    @click.stop="removeColor(item, i)">×</span>
                            </div>
                            <div class="px-[8px] py-[6px] rounded-[10px] text-[12px] cursor-pointer select-none border border-dashed bg-[#fafafa] text-[#6b7280] flex items-center gap-[4px]"
                                @click="addColor(item)">
                                <ElIcon size="14px">
                                    <Plus />
                                </ElIcon>
                                <span>添加颜色</span>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="item.inputType === 'upload'" style="flex: 1;">
                        <div class="flex flex-col gap-[12px]">
                            <input :ref="el => setUploadInputRef(item.key, el)" type="file" style="display:none"
                                :accept="item.accept || 'image/*'" multiple
                                @change="handleFilesSelected(item, $event)" />
                            <div class="upload-zone rounded-[12px] border bg-white w-full"
                                :class="dropActiveMap[item.key] ? 'border-[#a0cfff] bg-[#ecf5ff]' : 'border-[#e5e7eb] bg-white'"
                                @dragover.prevent="onDropZoneDragOver(item)"
                                @dragleave.prevent="onDropZoneDragLeave(item)"
                                @drop.prevent="onDropZoneDrop(item, $event)" @click="openFileDialog(item)">
                                <template v-if="Array.isArray(item.defaultValue) && item.defaultValue.length">
                                    <div class="p-[12px]">
                                        <div class="flex flex-wrap gap-[8px]">
                                            <div v-for="(f, i) in item.defaultValue" :key="i"
                                                class="relative group w-[80px] h-[80px] overflow-hidden rounded-[8px] bg-[#f3f4f6] flex items-center justify-center">
                                                <img v-if="f.isImage" :src="f.url" class="w-full h-full object-cover" />
                                                <img v-else-if="!f.url" :src="f" class="w-full h-full object-cover" />
                                                <span v-else class="text-[12px] text-[#6b7280]">文件</span>
                                                <div class="absolute top-[6px] right-[6px] w-[22px] h-[22px] bg-white rounded-full shadow border border-[#e5e7eb] cursor-pointer flex items-center justify-center"
                                                    @click.stop="removeFile(item, i)">
                                                    <ElIcon size="14px" class="text-[#303133]">
                                                        <Close />
                                                    </ElIcon>
                                                </div>
                                            </div>
                                            <div class="w-[80px] h-[80px] rounded-[8px] border border-dashed flex items-center justify-center cursor-pointer text-[#6b7280]"
                                                @click.stop="openFileDialog(item)">
                                                <ElIcon size="24px">
                                                    <Plus />
                                                </ElIcon>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="flex flex-col items-center justify-center h-[100px] select-none">
                                        <div
                                            class="w-[44px] h-[44px] rounded-full bg-[#f5f7fa] flex items-center justify-center mb-[10px]">
                                            <ElIcon size="20px" class="text-[#909399]">
                                                <Upload />
                                            </ElIcon>
                                        </div>
                                        <div class="text-[13px] text-[#303133]">
                                            <span class="text-[#409EFF] cursor-pointer"
                                                @click.stop="openFileDialog(item)">点击上传</span>
                                        </div>
                                        <div class="mt-[4px] text-[12px] text-[#909399]">支持 ZIP、RAR 格式</div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div v-if="item.inputType === 'template'" style="flex: 1;"
                        class="flex items-center justify-between gap-[12px]">
                        <el-select v-model="item.defaultValue" :placeholder="item.Placeholder" filterable
                            style="width: 100%">
                            <el-option v-for="template in item.options" :key="template.id" filterable
                                class="flex items-center justify-between" :value="template.value"
                                :label="template.label"><span>{{
                                    template.label
                                    }}</span> <el-button type="text" size="mini"
                                    @click.stop="editTemplate(template)">编辑</el-button></el-option>
                        </el-select>
                        <el-button type="primary" size="mini" @click="dialogVisible = true">添加模板</el-button>
                    </div>
                    <div v-else-if="item.inputType === 'title'" class="titleTyple" style="flex: 1;">
                        <div v-for="sub in (Array.isArray(item.options) ? item.options : [])"
                            :key="sub.key || sub.value" class="input-card px-[24px] py-[12px] gap-[12px]">
                            <div class="mb-[12px] pt-[6px] text-[14px] text-[#374151]">{{ sub.labelName }}：</div>
                            <div v-if="sub.inputType === 'cascader'" style="flex: 1;">
                                <el-cascader v-model="sub.defaultValue" :options="buildCascaderOptionsWithAdd(sub)"
                                    style="width: 100%" :placeholder="sub.Placeholder" :filterable="true">
                                    <template #default="{ data }">
                                        <div class="flex items-center w-full">
                                            <span>{{ data.label }}</span>
                                            <template v-if="data.isAddRoot">
                                                <el-input v-model="cascaderRootInputMap[sub.key]" size="small"
                                                    placeholder="输入后回车" class=" w-[140px]"
                                                    @keyup.enter="commitAddRoot(sub)" @blur="commitAddRoot(sub)" />
                                            </template>
                                            <template v-else-if="data.isAddChild">
                                                <el-input
                                                    v-model="cascaderChildInputMap[childMapKey(sub.key, data.parentValue)]"
                                                    size="small" placeholder="输入后回车" class=" w-[140px]"
                                                    @keyup.enter="commitAddChild(sub, data.parentValue)"
                                                    @blur="commitAddChild(sub, data.parentValue)" />
                                            </template>
                                        </div>
                                    </template>
                                </el-cascader>
                            </div>
                            <div v-else-if="sub.inputType === 'checkbox'" style="flex: 1;">
                                <div class="flex flex-wrap gap-[8px] items-center">
                                    <div v-for="opt in sub.options" :key="opt.value"
                                        class="px-[10px] py-[6px] rounded-[6px] text-[12px] cursor-pointer select-none border"
                                        :class="sub.defaultValue.includes(opt.value) ? 'bg-[#eef2ff] border-[#6366f1] text-[#3f51b5]' : 'bg-[#f9fafb] border-[#e5e7eb] text-[#374151]'"
                                        @click="toggleOption(sub, opt.value)">{{ opt.label }}</div>

                                    <template v-if="sub.customize">
                                        <template v-if="customizingMap[sub.key]">
                                            <el-input v-model="newOptionMap[sub.key]" size="small" placeholder="输入后回车添加"
                                                class="w-[140px]" @keyup.enter="commitCustomize(sub)"
                                                @blur="commitCustomize(sub)" />
                                        </template>
                                        <template v-else>
                                            <div class="px-[8px] py-[5px] rounded-[6px] text-[12px] cursor-pointer select-none border border-dashed bg-[#fafafa] text-[#6b7280] flex items-center gap-[4px]"
                                                @click="startCustomize(sub)">
                                                <ElIcon size="14px">
                                                    <Plus />
                                                </ElIcon>
                                            </div>
                                        </template>
                                    </template>
                                </div>
                            </div>
                            <div v-else-if="sub.inputType === 'multipleSelectCreate'" style="flex: 1;">
                                <el-input-tag v-model="sub.defaultValue" placeholder="输入完毕后请点击回车键" filterable clearable>
                                </el-input-tag>
                            </div>
                            <div v-else-if="sub.inputType === 'select'" style="flex: 1;">
                                <el-select v-model="sub.defaultValue" :placeholder="sub.Placeholder" filterable>
                                    <el-option v-for="opt in sub.options" :key="opt.value" :label="opt.label"
                                        :value="opt.value" />
                                </el-select>
                            </div>
                            <div v-else-if="sub.inputType === 'multipleSelect'" style="flex: 1;">
                                <el-select v-model="sub.defaultValue" :placeholder="sub.Placeholder" filterable
                                    multiple>
                                    <el-option v-for="opt in sub.options" :key="opt.value" :label="opt.label"
                                        :value="opt.value" />
                                </el-select>
                            </div>
                            <div v-else-if="sub.inputType === 'input'" style="flex: 1;">
                                <el-input v-model="sub.defaultValue" :placeholder="sub.Placeholder" />
                            </div>
                            <div v-else-if="sub.inputType === 'color'" style="flex: 1;">
                                <div class="flex items-center gap-[10px] flex-wrap">
                                    <div v-for="(c, i) in (Array.isArray(sub.defaultValue) ? sub.defaultValue : [])"
                                        :key="i"
                                        class="flex items-center gap-[10px] px-[12px] py-[8px] rounded-[10px] bg-[#f8fafc] border border-[#e5e7eb]">
                                        <input type="color" v-model="sub.defaultValue[i]"
                                            class="w-[20px] h-[20px] rounded-full border border-[#e5e7eb] p-0 cursor-pointer" />
                                        <span class="text-[12px] text-[#374151]">{{ c }}</span>
                                        <span class="text-[#9ca3af] cursor-pointer text-[12px]"
                                            @click.stop="removeColor(sub, i)">×</span>
                                    </div>
                                    <div class="px-[8px] py-[6px] rounded-[10px] text-[12px] cursor-pointer select-none border border-dashed bg-[#fafafa] text-[#6b7280] flex items-center gap-[4px]"
                                        @click="addColor(sub)">
                                        <ElIcon size="14px">
                                            <Plus />
                                        </ElIcon>
                                        <span>添加颜色</span>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="sub.inputType === 'upload'" style="flex: 1;">
                                <div class="flex flex-col gap-[12px]">
                                    <input :ref="el => setUploadInputRef(sub.key, el)" type="file" style="display:none"
                                        :accept="sub.accept || 'image/*'" multiple
                                        @change="handleFilesSelected(sub, $event)" />
                                    <div class="upload-zone rounded-[12px] border bg-white w-full"
                                        :class="dropActiveMap[sub.key] ? 'border-[#a0cfff] bg-[#ecf5ff]' : 'border-[#e5e7eb] bg-white'"
                                        @dragover.prevent="onDropZoneDragOver(sub)"
                                        @dragleave.prevent="onDropZoneDragLeave(sub)"
                                        @drop.prevent="onDropZoneDrop(sub, $event)" @click="openFileDialog(sub)">
                                        <template v-if="Array.isArray(sub.defaultValue) && sub.defaultValue.length">
                                            <div class="p-[12px]">
                                                <div class="flex flex-wrap gap-[8px]">
                                                    <div v-for="(f, i) in sub.defaultValue" :key="i"
                                                        class="relative group w-[80px] h-[80px] overflow-hidden rounded-[8px] bg-[#f3f4f6] flex items-center justify-center">
                                                        <img v-if="f.isImage" :src="f.url"
                                                            class="w-full h-full object-cover" />
                                                        <img v-else-if="!f.url" :src="f"
                                                            class="w-full h-full object-cover" />
                                                        <span v-else class="text-[12px] text-[#6b7280]">文件</span>
                                                        <div class="absolute top-[6px] right-[6px] w-[22px] h-[22px] bg-white rounded-full shadow border border-[#e5e7eb] cursor-pointer flex items-center justify-center"
                                                            @click.stop="removeFile(sub, i)">
                                                            <ElIcon size="14px" class="text-[#303133]">
                                                                <Close />
                                                            </ElIcon>
                                                        </div>
                                                    </div>
                                                    <div class="w-[80px] h-[80px] rounded-[8px] border border-dashed flex items-center justify-center cursor-pointer text-[#6b7280]"
                                                        @click.stop="openFileDialog(sub)">
                                                        <ElIcon size="24px">
                                                            <Plus />
                                                        </ElIcon>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div
                                                class="flex flex-col items-center justify-center h-[100px] select-none">
                                                <div
                                                    class="w-[44px] h-[44px] rounded-full bg-[#f5f7fa] flex items-center justify-center mb-[10px]">
                                                    <ElIcon size="20px" class="text-[#909399]">
                                                        <Upload />
                                                    </ElIcon>
                                                </div>
                                                <div class="text-[13px] text-[#303133]">
                                                    <span class="text-[#409EFF] cursor-pointer"
                                                        @click.stop="openFileDialog(sub)">点击上传</span>
                                                </div>
                                                <div class="mt-[4px] text-[12px] text-[#909399]">支持 ZIP、RAR 格式</div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="tips text-[12px] text-[#aaa] mt-[10px]">{{ item.tips }}</div>
                        </div>

                    </div>
                    <div class="tips text-[12px] text-[#aaa] mt-[10px]">{{ item.tips }}</div>
                </div>
            </div>
            <div class="btn flex justify-center mt-[20px]">
                <el-button style="width: 200px;" type="primary" @click="cancelsubmit">取消</el-button>
                <el-button style="width: 200px;" type="primary" @click="uploadTemplate">提交场景</el-button>
            </div>
            <!-- <div class=" px-[24px] py-[12px] gap-[12px]">
                <div class="mb-[12px] pt-[6px] text-[14px] text-[#374151] font-bold">item.labelName：</div>
                <div style="flex: 1;">
                    <el-input v-model="defaultValue" placeholder="Placeholder" />
                </div>
            </div>
            <div class=" px-[24px] py-[12px] gap-[12px]">
                <div class="mb-[12px] pt-[6px] text-[14px] text-[#374151] font-bold">item.labelName：</div>
                <div style="flex: 1;">
                    <el-input v-model="defaultValue" placeholder="Placeholder" />
                </div>
            </div>
            <div class=" px-[24px] py-[12px] gap-[12px]">
                <div class="mb-[12px] pt-[6px] text-[14px] text-[#374151] font-bold">item.labelName：</div>
                <div style="flex: 1;">
                    <el-input v-model="defaultValue" placeholder="Placeholder" />
                </div>
            </div>
            <div class=" px-[24px] py-[12px] gap-[12px]">
                <div class="mb-[12px] pt-[6px] text-[14px] text-[#374151] font-bold">item.labelName：</div>
                <div style="flex: 1;">
                    <el-input v-model="defaultValue" placeholder="Placeholder" />
                </div>
            </div>
            <div class=" px-[24px] py-[12px] gap-[12px]">
                <div class="mb-[12px] pt-[6px] text-[14px] text-[#374151] font-bold">item.labelName：</div>
                <div style="flex: 1;">
                    <el-input v-model="defaultValue" placeholder="Placeholder" />
                </div>
            </div>
            <div class=" px-[24px] py-[12px] gap-[12px]">
                <div class="mb-[12px] pt-[6px] text-[14px] text-[#374151] font-bold">item.labelName：</div>
                <div style="flex: 1;">
                    <el-input v-model="defaultValue" placeholder="Placeholder" />
                </div>
            </div>
            <div class=" px-[24px] py-[12px] gap-[12px]">
                <div class="mb-[12px] pt-[6px] text-[14px] text-[#374151] font-bold">item.labelName：</div>
                <div style="flex: 1;">
                    <el-input v-model="defaultValue" placeholder="Placeholder" />
                </div>
            </div> -->
        </div>
    </div>
    <el-dialog v-model="dialogVisible" title="" width="430" top="100px" append-to-body>
        <size @create="createDesign" type="addtemplate" />
    </el-dialog>
    <NewLoading fullscreen v-if="uploadsLoading" />
</template>
<script setup lang="ts">
import { onMounted, nextTick, ref, watch, onBeforeUnmount } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessageBox } from 'element-plus'
import { initGlobalConfig } from '@/common/initGlobalConfig'
import { initClient } from '@/common/inituser'
import { useMiscStore } from '@/stores/misc'
import { useUserStore } from '@/stores/user'
const uploadsLoading = ref(false)
const dialogVisible = ref(false)
//@ts-ignore
import Editer from '@/components/Editer/Editer.vue'
//@ts-ignore
import NewLoading from '@/components/loading/loadingComp.vue'
//@ts-ignore
import team from '@/components/topPanel/team/team.vue'
//@ts-ignore
import login from '@/components/topPanel/login/login.vue'
//@ts-ignore
import size from '@/components/fileActions/createDesign/size.vue'
import { getHoverInfo, uploadfiles, saveTemplate, analyzeText } from '@/api/plugin'
import { createCategory, createTag } from '@/api/ResourceMasonry'
const userStore = useUserStore()
const islogin = userStore.isLoggedIn
const rightpanelshow = ref(false)
import { ElMessage } from 'element-plus'
const inputTree = ref([])
const inputsRef = ref<HTMLElement | null>(null)
const updateColumnsWidth = () => {
    const el = inputsRef.value
    if (!el) return
    const cs = getComputedStyle(el)
    const w = parseFloat(cs.columnWidth || '0') || 360
    const g = parseFloat(cs.columnGap || '0') || 20
    const children = Array.from(el.children) as HTMLElement[]
    const used = new Set(children.map(c => c.offsetLeft))
    const n = Math.min(3, used.size)
    if (n >= 3) {
        el.style.width = '100%'
        el.style.marginLeft = '0'
        el.style.marginRight = '0'
    } else {
        const target = n > 0 ? (n * w + (n - 1) * g) : w
        const max = el.parentElement ? el.parentElement.clientWidth : target
        el.style.width = `${Math.min(target, max)}px`
        el.style.marginLeft = 'auto'
        el.style.marginRight = 'auto'
    }
}
onMounted(async () => {
    await initGlobalConfig()
    await initClient()
    if (!islogin) {
        (window as any).openGlobalLogin?.()
        return
    };
    rightpanelshow.value = true
    getHoverInfos()
    nextTick(updateColumnsWidth)
    window.addEventListener('resize', updateColumnsWidth)
})
const getHoverInfos = async (params?: any) => {
    const corpCode = userStore.currentTeamInfo?.corp_code
    const res = await getHoverInfo({
        'role_id': localStorage.getItem('role_id') || '',
        'corp_code': corpCode,
        ...params
    })
    console.log(res.data?.data)
    if (res.data?.data) {
        inputTree.value = res.data?.data;

    }
    nextTick(updateColumnsWidth)
}

watch(inputTree, () => nextTick(updateColumnsWidth), { deep: true })
onBeforeUnmount(() => {
    window.removeEventListener('resize', updateColumnsWidth)
})


const fileFromUrl = async (url: string, filename?: string) => {
    const res = await fetch(url)
    const blob = await res.blob()
    const name = filename || `file_${Date.now()}`
    return new File([blob], name, { type: blob.type || 'application/octet-stream' })
}
const uploadFile = async (filesList: any) => {
    let urllist: string[] = []
    for (let file of filesList) {
        if (!file.url) {
            urllist.push(file)
        } else {
            const fobj = await fileFromUrl(file.url, file.name)
            let formData = new FormData()
            formData.append('file', fobj, file.name)
            let res = await uploadfiles(formData)
            urllist.push(res.data?.data[0].url || '')
        }

        // if (res.data?.data?.url) {
        //     urllist.push(res.data?.data?.url)
        // }
    }
    return urllist
}
const uploadTemplate = async () => {
    uploadsLoading.value = true
    let list = (inputTree.value as any[]).filter((item: any) => item.inputType === 'title')
    let newList = [...inputTree.value, ...list.flatMap((l: any) => l.options || [])]
    let data = {}
    for (let item of newList) {
        if (!(item as any).custom && (item as any).inputType != 'upload' && (item as any).defaultValue) {
            try {
                data[(item as any).key] = (item as any).defaultValue.join(',')
            } catch (error) {
                data[(item as any).key] = (item as any).defaultValue
            }
        } else if ((item as any).inputType == 'upload') {
            let urllist = await uploadFile((item as any).defaultValue)
            data[(item as any).key] = urllist.join(',')
        }

    }
    let params = {
        dictionary: data
    }
    let res = await saveTemplate(params)
    uploadsLoading.value = false
    if (res.data?.code == 200) {
        ElMessage.success(res.data?.message || '上传成功')
        getHoverInfos()
    } else {
        ElMessage.error(res.data?.message || '上传失败')
    }
    // 
    // console.log(JSON.stringify(data))



}

const uploadInputRefs = ref<Record<string, HTMLInputElement | null>>({})
const setUploadInputRef = (key: string, el: HTMLInputElement | null) => {
    if (el) uploadInputRefs.value[key] = el
}
const openFileDialog = (item: any) => {
    const el = uploadInputRefs.value[item.key]
    if (el) el.click()
}
const dropActiveMap = ref<Record<string, boolean>>({})
const onDropZoneDragOver = (item: any) => {
    dropActiveMap.value[item.key] = true
}
const onDropZoneDragLeave = (item: any) => {
    dropActiveMap.value[item.key] = false
}
const onDropZoneDrop = (item: any, e: DragEvent) => {
    dropActiveMap.value[item.key] = false
    const files = Array.from(e.dataTransfer?.files || [])
    const arr = Array.isArray(item.defaultValue) ? [...item.defaultValue] : (item.defaultValue = [])
    const accepts = String(item.accept || '').split(',').map(s => s.trim().toLowerCase()).filter(Boolean)
    for (const file of files) {
        if (accepts.length && !acceptMatches(file, accepts)) continue
        const url = URL.createObjectURL(file)
        arr.push({ id: `${Date.now()}_${Math.random()}`, name: file.name, size: file.size, url, type: file.type, isImage: file.type.startsWith('image/') })
    }
    item.defaultValue = arr
}
const acceptMatches = (file: File, tokens: string[]) => {
    if (!tokens.length) return true
    const ext = '.' + String(file.name.split('.').pop() || '').toLowerCase()
    const type = String(file.type || '').toLowerCase()
    return tokens.some(t => {
        if (!t) return false
        if (t.startsWith('.')) return ext === t
        if (t.endsWith('/*')) return type.startsWith(t.slice(0, -1))
        return type === t
    })
}
const handleFilesSelected = (item: any, e: Event) => {
    const input = e.target as HTMLInputElement
    const files = Array.from(input.files || [])
    const arr = Array.isArray(item.defaultValue) ? [...item.defaultValue] : (item.defaultValue = [])
    const accepts = String(item.accept || '').split(',').map(s => s.trim().toLowerCase()).filter(Boolean)
    // console.log(accepts)
    for (const file of files) {
        // if (accepts.length && !acceptMatches(file, accepts)) continue
        const url = URL.createObjectURL(file)

        arr.push({ id: `${Date.now()}_${Math.random()}`, name: file.name, size: file.size, url, type: file.type, isImage: file.type.startsWith('image/') })
    }

    item.defaultValue = arr
    input.value = ''
}
const removeFile = (item: any, idx: number) => {
    const arr = Array.isArray(item.defaultValue) ? item.defaultValue : []
    const f = arr[idx]
    if (f && f.url) URL.revokeObjectURL(f.url)
    arr.splice(idx, 1)
    item.defaultValue = [...arr]
}
const formatSize = (size: number) => {
    if (size < 1024) return `${size} B`
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`
    return `${(size / 1024 / 1024).toFixed(1)} MB`
}

const addColor = (item: any) => {
    const arr = Array.isArray(item.defaultValue) ? [...item.defaultValue] : []
    arr.push('#409EFF')
    item.defaultValue = arr
}
const removeColor = (item: any, idx: number) => {
    const arr = Array.isArray(item.defaultValue) ? item.defaultValue : []
    if (idx >= 0 && idx < arr.length) {
        arr.splice(idx, 1)
        item.defaultValue = [...arr]
    }
}







const customizingMap = ref<Record<string, boolean>>({})
const newOptionMap = ref<Record<string, string>>({})
const cascaderRootInputMap = ref<Record<string, string>>({})
const cascaderChildInputMap = ref<Record<string, string>>({})
const childMapKey = (itemKey: string, parentValue: string) => `${itemKey}::${String(parentValue)}`
const toggleOption = (item: any, value: any) => {
    const arr = Array.isArray(item.defaultValue) ? [...item.defaultValue] : []
    const idx = arr.indexOf(value)
    if (idx >= 0) {
        arr.splice(idx, 1)
    } else {
        arr.push(value)
    }
    item.defaultValue = arr
}
const MinusCustom = (ind: number) => {
    const custom = inputTree.value.find((item: any) => item.custom)
    if (!custom) return
    const list = Array.isArray((custom as any).list) ? (custom as any).list : ((custom as any).list = [])
    if (ind >= 0 && ind < list.length) {
        list.splice(ind, 1)
    }
}
const addCustom = () => {
    const custom = inputTree.value.find((item: any) => item.custom)
    if (!custom) return
    const list = Array.isArray((custom as any).list) ? (custom as any).list : ((custom as any).list = [])
    list.push({ 'key': '', 'value': '' })
}
const startCustomize = (item: any) => {
    customizingMap.value[item.key] = true
    newOptionMap.value[item.key] = ''
}
const commitCustomize = async (item: any) => {
    const key = item.key
    const v = (newOptionMap.value[key] || '').trim()
    customizingMap.value[key] = false
    if (!v) return
    const opts = Array.isArray(item.options) ? item.options : (item.options = [])
    if (opts.some((o: any) => String(o.value) === v)) {
        newOptionMap.value[key] = ''
        return
    }
    const id = await addTag(v, key)
    if (typeof id === 'number' && id > 0) {
        opts.push({ value: id, label: v })
    }
    toggleOption(item, id)
    newOptionMap.value[key] = ''
}
const buildCascaderOptionsWithAdd = (item: any) => {
    const opts = Array.isArray(item.options) ? item.options : []
    const roots = opts.map((o: any) => {
        const children = Array.isArray(o.children) ? o.children.map((c: any) => ({ ...c })) : []
        children.unshift({
            value: `__addchild__:${String(o.value)}`,
            label: '',
            disabled: true,
            isAddChild: true,
            parentValue: String(o.value)
        })
        return { ...o, children }
    })
    roots.unshift({ value: '__addroot__', label: '', disabled: true, isAddRoot: true })
    return roots
}
const commitAddRoot = async (item: any) => {
    const key = item.key
    const v = (cascaderRootInputMap.value[key] || '').trim()
    if (!v) return
    const opts = Array.isArray(item.options) ? item.options : (item.options = [])
    if (opts.some((o: any) => String(o.value) === v)) {
        cascaderRootInputMap.value[key] = ''
        return
    }
    const id = await addCategory(v, 0)
    if (typeof id === 'number' && id > 0) {
        opts.unshift({ value: id, label: v, children: [] })
        cascaderRootInputMap.value[key] = ''
    }


}
const handleRemove = (e: any, item: any) => {
    e.preventDefault()
    const idx = item.defaultValue.indexOf(e.file)
    if (idx >= 0) {
        item.defaultValue.splice(idx, 1)
    }
}
const commitAddChild = async (item: any, parentValue: string) => {
    const key = childMapKey(item.key, String(parentValue))
    const v = (cascaderChildInputMap.value[key] || '').trim()
    if (!v) return
    const opts = Array.isArray(item.options) ? item.options : (item.options = [])
    const parent = opts.find((o: any) => String(o.value) === String(parentValue))
    if (!parent) {
        cascaderChildInputMap.value[key] = ''
        return
    }
    const children = Array.isArray(parent.children) ? parent.children : (parent.children = [])
    if (children.some((c: any) => String(c.value) === v)) {
        cascaderChildInputMap.value[key] = ''
        return
    }
    const id = await addCategory(v, Number(parentValue))
    console.log(id)
    if (typeof id === 'number' && id > 0) {
        children.unshift({ value: id, label: v })
        cascaderChildInputMap.value[key] = ''
    }

}
const addCategory = async (name: string, parent_id: number) => {
    const res = await createCategory({ name: name, owner_type: ((userStore.currentTeamInfo?.corp_code) ? 'team' : 'user'), corp_code: ((userStore.currentTeamInfo?.corp_code) || ''), parent_id: parent_id })
    if (res.data.data.id) {
        return res.data.data.id
    } else {
        return 0
    }

}
const addTag = async (name: string, key: string) => {
    const res = await createTag({ name: name, owner_type: ((userStore.currentTeamInfo?.corp_code) ? 'team' : 'user'), corp_code: ((userStore.currentTeamInfo?.corp_code) || ''), key: key })
    if (res.data.data.id) {
        return res.data.data.id
    } else {
        return 0
    }
}



const createDesign = async (createParams: any) => {

    let template = inputTree.value.find((item: any) => item.inputType === 'template')
    console.log(template, 'asdasdasdasdasd')
    if (template && (template as any).options) {
        (template as any).options.push({ value: createParams.id, label: '新建模板' })
    }

    if (template && (template as any).defaultValue !== undefined) (template as any).defaultValue = createParams.id
    dialogVisible.value = false
    // console.log(createParams)
    // if (res.data.data.pk) {
    //     return res.data.data.pk
    // } else {
    //     return 0
    // }
}

const editTemplate = (template: any) => {
    dialogVisible.value = true
    const params = new URLSearchParams({
        id: String(template.value),
        mode: 'user',

    })
    window.open(`/editor?${params.toString()}`, '_blank')
}

const cancelsubmit = () => {
    getHoverInfos()
}

const analyzeTextBYAI = async () => {

    const found = inputTree.value.find((item: any) => item.key === 'title')
    const title = found ? (found as any).defaultValue : ''
    const findItemsByKey = (list: any[], key: string): any[] => {
        const res: any[] = []
        const dfs = (nodes: any[]) => {
            for (const node of nodes) {
                if (!node || typeof node !== 'object') continue
                if ((node as any).key === key) res.push(node)
                const opts = (node as any).options
                if (Array.isArray(opts)) dfs(opts)
            }
        }
        dfs(list)
        return res
    }
    const imgs = findItemsByKey(inputTree.value as any[], 'scene_file')
    const imgUrlList = imgs.flatMap((it: any) => Array.isArray(it.defaultValue) ? it.defaultValue : [])
    if (!title && (!imgUrlList || imgUrlList.length === 0)) {
        ElMessage.error('请至少填写标题或上传图片')
        return
    }
    uploadsLoading.value = true
    let imglist: string[] = []
    if (Array.isArray(imgUrlList) && imgUrlList.length > 0) {
        imglist = await uploadFile(imgUrlList)
    }

    const payload: any = {}
    if (title) payload.text = title
    if (imglist.length > 0) payload.imageBase64 = imglist.join(',')
    const res = await analyzeText(payload)

    if (res.data.code == 200) {
        const params: any = { aiResult: res.data.data }
        if (title) params.text = title
        if (imglist.length > 0) params.imageBase64 = imglist.join(',')
        uploadsLoading.value = false
        getHoverInfos(params)
    } else {
        uploadsLoading.value = false
    }
    // if (res.data.data) {
    //     inputTree.value.find((item: any) => item.key === 'title').defaultValue = res.data.data.title
    // }
}









</script>
<style scoped lang="scss">
.party-upload {
    width: 100vw;
    display: flex;
    height: 100vh;
    flex-direction: column;

    #doms {
        width: 100%;
    }

    .insputs {
        display: block;
        min-height: calc(100vh - 60px);
        column-count: 3;
        column-fill: balance-all;

        overflow-y: auto;
        margin: 0 auto;
    }

    .break-inside-avoid {
        break-inside: avoid;
        -webkit-column-break-inside: avoid;
        -moz-column-break-inside: avoid;
        display: block;
        width: 100%;
    }

    .titleTyple {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
    }
}
</style>
<style scoped lang="scss">
.party-upload .insputs {
    column-gap: 12px;
    padding: 12px;
    background: #f8fafc;
}

.input-card {
    background: #fff;
    border: 1px solid #eef1f5;
    border-radius: 12px;
    box-shadow: 0 1px 2px rgba(31, 35, 40, 0.04);
    margin: 8px 0;
}

.upload-zone {
    transition: border-color .2s ease, box-shadow .2s ease, background-color .2s ease;
}

.upload-zone:hover {
    border-color: #a0cfff;
    box-shadow: 0 2px 6px rgba(31, 35, 40, 0.06);
    background-color: #f9fbff;
}

:deep(.el-input__wrapper),
:deep(.el-textarea__inner) {
    border-radius: 8px;
}

:deep(.el-input__wrapper.is-focus),
:deep(.el-select .el-input__wrapper.is-focus),
:deep(.el-textarea__inner:focus) {
    border-color: #2a66ff !important;
    box-shadow: 0 0 0 1px rgba(42, 102, 255, 0.2);
}

.party-upload .titleTyple {
    gap: 8px;
}
</style>
